import { Dialog } from "@headlessui/react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import FormInput from "../../../components/controls/FormInput";
import CitySelector from "../../../components/dropdowns/CitySelector";
import { useAuth } from "../../../contexts/AuthContext";
import FormTextarea from "../../../components/controls/FormTextArea";

export default function CreateCompanyModal({
  isOpen,
  onClose,
  cityId,
  onCompanyCreated,
  cityIdChanged,
}) {
  const { t } = useTranslation();
  const { currentUser } = useAuth();

  const [selectedCityId, setSelectedCityId] = useState(cityId || null);
  const [name, setName] = useState("");
  const [note, setNote] = useState(""); // NOUVEAU
  const [assignSelf, setAssignSelf] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setSelectedCityId(cityId);
      setName("");
      setNote(""); // NOUVEAU
      setAssignSelf(true);
      cityIdChanged(cityId);
    }
  }, [isOpen, cityId]);

  const handleCreate = async () => {
    try {
      const payload = {
        name,
        cityId: selectedCityId,
        createdBy: currentUser?.id,
        assignedTo: assignSelf ? currentUser?.id : null,
        note: note.trim() || null,
      };

      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/Representative/CompaniesToContact`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      onCompanyCreated?.(payload);
      onClose();
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <div className="fixed inset-0 bg-black/40 z-40 " />
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-xl max-h-[90vh] overflow-y-auto">
          <h2 className="text-xl font-bold mb-4 text-primary">
            {t("reservation.addCompany")}
          </h2>

          <div className="mb-4">
            <CitySelector value={selectedCityId} onChange={setSelectedCityId} />
          </div>

          <FormInput
            name="name"
            label={t("reservation.companyName")}
            value={name}
            onChange={(name, value) => setName(value)}
            required
          />

          {/* NOUVEAU CHAMP NOTE */}
          <div className="mb-4">
            <FormTextarea
              value={note}
              label={t("global.note")}
              name="note"
              onChange={(name, value) => setNote(value)}
              placeholder={"Ex: # Téléphone, Email, Adresse, lien Facebook..."}
              rows={3}
              maxLength={500}
              showMaxLength
              required
            />
          </div>

          <label className="flex items-center mt-4 gap-2 text-primary">
            <input
              type="checkbox"
              checked={assignSelf}
              onChange={(e) => setAssignSelf(e.target.checked)}
              className="checkbox"
            />
            {t("reservation.assignToMe")}
          </label>

          <div className="flex justify-end gap-2 mt-6">
            <button onClick={onClose} className="btn btn-ghost">
              {t("global.cancel")}
            </button>
            <button
              onClick={handleCreate}
              className="btn bg-primary text-white rounded-full"
            >
              {t("global.save")}
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
